import { IntroIFrame, IntroWrapper } from './__intro-elements';
import { IntroKeys } from './intro-keys';

const NavFc = () => (
  <IntroWrapper>
    <p>
      <b>Final Cuts</b> page: Access your rendered Final Cuts.
    </p>
  </IntroWrapper>
);

const FcIntro = () => (
  <IntroWrapper size="medium">
    <p>
      You can preview, upgrade, share, and download your rendered <b>Final Cuts</b> here.
    </p>
    <p>
      The storyboards are read only on the Final Cut tracks. If you want to make changes use the track to locate clips
      and navigate back to the Storyboard to make your changes and re-render.
    </p>
    <IntroIFrame src="https://youtube.com/embed/nRubnuj_1mI" />
  </IntroWrapper>
);

const FcElem = () => (
  <IntroWrapper>
    <p>
      Select a <b>Final Cut</b> in the list. You may have multiple Final Cuts here.
    </p>
  </IntroWrapper>
);

const FcPlay = () => (
  <IntroWrapper>
    <p>
      <b>Preview</b> your Final Cut here.
    </p>
  </IntroWrapper>
);

const FcUpgrade = () => (
  <IntroWrapper>
    <p>
      <b>Upgrade</b> your Final Cut here. Remove watermarks, increase resolution, etc.
    </p>
  </IntroWrapper>
);

const FcDownload = () => (
  <IntroWrapper>
    <p>
      <b>Download</b> your Final Cut to your computer. You can also use the download utility on the player.
    </p>
  </IntroWrapper>
);

const FcShare = () => (
  <IntroWrapper>
    <p>
      <b>Share</b> your Final Cut to social media.
    </p>
  </IntroWrapper>
);

const FcFinished = () => (
  <IntroWrapper>
    <p>
      Congratulations — You are <b>finished</b>!
    </p>
    <p>
      But you can always go back to the <b>Highlights</b> and <b>Storyboard</b> pages to make additional modifications
      and re-render.
    </p>
  </IntroWrapper>
);

export const STEPS_FC = [
  { element: `[data-intro="${IntroKeys.navFc}"]`, intro: <NavFc /> },
  { intro: <FcIntro /> },
  { element: `[data-intro="${IntroKeys.fcElem}"]`, intro: <FcElem /> },
  { element: `[data-intro="${IntroKeys.fcPlay}"]`, intro: <FcPlay /> },
  { element: `[data-intro="${IntroKeys.fcUpgrade}"]`, intro: <FcUpgrade /> },
  { element: `[data-intro="${IntroKeys.fcDownload}"]`, intro: <FcDownload /> },
  { element: `[data-intro="${IntroKeys.fcShare}"]`, intro: <FcShare /> },
  { intro: <FcFinished /> },
];
